<template>
  <div>
    <div
      v-if="loading"
      id="carregaDados"
      class="text-center"
      :style="styleObject"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando Dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div>
      <div id="mapParticipantes" />
      <div v-if="!enableTable">
        <v-icon
          id="iconDistribuicaoClientes"
          class="text-center"
          @click="exibirTabela()"
        >
          mdi-chevron-down-box
        </v-icon>
        Exibir legenda
      </div>
      <div v-else>
        <v-icon
          id="iconDistribuicaoClientes"
          class="text-center"
          @click="exibirTabela()"
        >
          mdi-chevron-up-box
        </v-icon>
        Recolher legenda
        <div
          id="idTable"
          style="overflow-x: auto;"
        >
          <table
            style="width: 100%; color: black; border-collapse: collapse;"
            class="elevation-1"
            mobile-breakpoint="0"
          >
            <tbody>
              <tr
                v-for="item in clientesLegenda"
                :key="item.id"
              >
                <td
                  id="dadoMovimentacao"
                  style="text-align: center;"
                >
                  <v-chip
                    class="pa-2 rounded-circle"
                    :color="item.cor"
                    x-small
                    dark
                  />
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: left;"
                >
                  {{ item.nome }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.numero }}
                </td>
                <td
                  id="dadoMovimentacao"
                  style="text-align: right;"
                >
                  {{ item.porcentagem }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Cliente from '../../../../services/clientes'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardMapsCliente',
    emits: ['dadosMapsCliente'],
    data () {
      return {
        center: {
          lat: -20.7523412,
          lng: -42.8732878,
          tooltip: 'Magistech',
        },
        locations: [],
        corsLegend: [
          { corBackground: '#ea4335', corGlyph: '#b31412' },
          { corBackground: '#64B5F6', corGlyph: '#2196F3' },
          { corBackground: '#8D6E63', corGlyph: '#795548' },
          { corBackground: '#26A69A', corGlyph: '#009688' },
          { corBackground: '#C8E6C9', corGlyph: '#4CAF50' },
          { corBackground: '#FFF176', corGlyph: '#FBC02D' },
          { corBackground: '#FFB74D', corGlyph: '#FF9800' },
          { corBackground: '#EEEEEE', corGlyph: '#9E9E9E' },
          { corBackground: '#BA68C8', corGlyph: '#9C27B0' },
        ],
        styleObject: {
          color: localStorage.corPrimaria,
        },
        marker: '',
        enableTable: false,
        indiceLegenda: [],
        currentLocation: null,
        primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
        dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
        select: [],
        cepGeocalizacao: [],
        vendedorSelect: [],
        areaSelect: [],
        redeSelect: [],
        supervisorSelect: [],
        receita: [],
        segmento: [],
        categoria: [],
        promotor: [],
        zoom: 6,
        window_open: false,
        info_marker: null,
        infowindow: {
          lat: -20.7523412,
          lng: -42.8732878,
          tooltip: 'Magistech',
        },
        clientesLegenda: [],
        headersClientes: [
          { text: 'Cor', value: 'cor', width: '0.5px', align: 'right', class: 'black--text title' },
          { text: 'Nome', value: 'nome', width: '250px', align: 'left', class: 'black--text title', sytle: 'margin-left: -1rem' },
          { text: 'Quantidade', value: 'numero', width: '150px', align: 'right', class: 'black--text title' },
          { text: 'Porcentagem', value: 'porcentagem', width: '150px', align: 'right', class: 'black--text title' },
        ],
        loading: false,
        error: null,
        enableMap: true,
        markers: [],
      }
    },

    created () {
      eventEmit.$on('set-localizcao-cliente', this.handleUpdateDados)

      eventEmit.$on('exibir-legenda-maps-print', this.handleLegendaPrint)

      eventEmit.$on('enable-map', this.handleMap)

      eventEmit.$on('disable-map', this.disableMap)
    },

    beforeDestroy () {
      eventEmit.$off('set-localizcao-cliente', this.handleUpdateDados)

      eventEmit.$off('exibir-legenda-maps-print', this.handleLegendaPrint)

      eventEmit.$off('enable-map', this.handleMap)

      eventEmit.$off('disable-map', this.disableMap)
    },

    mounted () {
      const map = new window.google.maps.Map(document.getElementById('mapParticipantes'), {
        center: this.center,
        zoom: 14,
        mapId: '39ddaa6e92a6459f',
      })

      // eslint-disable-next-line no-unused-vars
      const markerView = new window.google.maps.marker.AdvancedMarkerView({
        map,
        position: this.center,
        title: this.center.tooltip,
      })
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, vendedor, area, rede, supervisor, receita, segmento, categoria, promotor) {
        this.primeiroDia = primeiroDia
        this.dataFinal = dataFinal
        this.select = select
        this.vendedorSelect = vendedor
        this.areaSelect = area
        this.redeSelect = rede
        this.supervisorSelect = supervisor
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor

        this.center = {
          lat: -20.7523412,
          lng: -42.8732878,
          tooltip: 'Magistech',
        }

        this.mapaInicial()

        this.atualizaGrafico()
      },

      handleLegendaPrint (value) {
        this.enableTable = true
      },

      handleMap (value, clientes, locations, zoom, center) {
        this.enableMap = value

        this.clientesLegenda = clientes

        this.zoom = zoom

        this.center = center

        this.locations = locations

        this.updateMap()
      },

      disableMap (value) {
        this.enableMap = value
      },

      openWindow (tooltip) {
        this.infowindow = {
          lat: tooltip.lat,
          lng: tooltip.lng,
          tooltip: tooltip.tooltip,
        }

        this.window_open = true
      },

      setMarker () {
        const contentCenter = { background: this.center.corBackground, glyphColor: this.center.corGlyph, borderColor: this.center.corBackground }

        const map = new window.google.maps.Map(document.getElementById('mapParticipantes'), {
          center: this.center,
          zoom: 12,
          mapId: '39ddaa6e92a6459f',
          title: this.center.tooltip,
          content: contentCenter,
        })

        // Create an info window to share between markers.
        const infoWindow = new window.google.maps.InfoWindow()

        this.locations.forEach(location => {
          // Adicionar cor marcadores
          const pinViewBackground = new window.google.maps.marker.PinView({
            background: location.corBackground,
            glyphColor: location.corGlyph,
            borderColor: location.corBackground,
          })

          // Adicionar marcadores
          const marker = new window.google.maps.marker.AdvancedMarkerElement({
            position: { lat: location.lat, lng: location.lng },
            map: map,
            title: location.tooltip,
            content: pinViewBackground.element,
          })

          marker.addListener('gmp-click', (event) => {
            infoWindow.close()
            infoWindow.setContent(marker.title)
            infoWindow.open(marker.map, marker)
          })

          this.markers.push(marker)
        })
      },

      updateMap () {
        this.setMarker()
      },

      mapaInicial () {
        this.clientesLegenda = []
        this.locations = []
        this.center = {
          lat: -20.7523412,
          lng: -42.8732878,
          name: 'Magistech',
        }

        const map = new window.google.maps.Map(document.getElementById('mapParticipantes'), {
          center: this.center,
          zoom: 14,
          mapId: '39ddaa6e92a6459f',
        })

        // eslint-disable-next-line no-unused-vars
        const markerView = new window.google.maps.marker.AdvancedMarkerView({
          map,
          position: this.center,
          title: this.center.name,
        })
      },

      async atualizaGrafico () {
        this.loading = true

        await Cliente.showLocalizacaoCliente(this.primeiroDia, this.dataFinal, this.select, localStorage.tokencontrato, this.vendedorSelect, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receita, this.segmento, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.clientesLegenda = resposta.data.legenda.map((item) => {
              var listaLegenda = ({
                nome: item.nome,
                numero: item.numero,
                porcentagem: item.porcentagem.toFixed(2) + '%',
                cor: this.corsLegend[item.codigo].corBackground,
              })

              return listaLegenda
            })

            this.zoom = 12

            this.locations = resposta.data.geoLocalizacao.map((item) => {
              var listaLocations = ({
                lat: item.latitude,
                lng: item.longitude,
                tooltip: item.nome_legenda,
                corBackground: this.corsLegend[item.codigo].corBackground,
                corGlyph: this.corsLegend[item.codigo].corGlyph,
              })

              return listaLocations
            })

            this.center = this.locations[0]

            this.setMarker()
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false

          eventEmit.$emit('dados-maps-cliente', this.clientesLegenda, this.locations, this.zoom, this.center)
        })
      },

      setPlace (loc) {
        this.currentLocation = loc
      },

      exibirTabela () {
        if (this.enableTable) {
          this.enableTable = false
        } else {
          this.enableTable = true
        }
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 680px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

   #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #map {
    height: 400px;
  }

  #mapParticipantes {
    height: 400px;
  }
</style>
